import React, {Component, PropTypes} from 'react'

class ButtonToggle extends Component {
    static propTypes = {
        multi: PropTypes.bool,
        identify: PropTypes.func,
        value: PropTypes.any,
        onChange: PropTypes.func.isRequired
    }

    static defaultProps = {
        identify: (v) => v
    }

    _toggle(event, item) {
        const {multi, value, onChange, identify} = this.props

        event.preventDefault()

        var nextValue

        if (multi) {
            const previousValue = value || []
            const itemId = identify(item)
            const index = previousValue.findIndex((v) => identify(v) == itemId)

            nextValue = [...previousValue]
            if (index >= 0) {
                nextValue.splice(index, 1)
            } else {
                nextValue.push(item)
            }
        } else {
            if ((value && identify(value)) != identify(item)) {
                nextValue = item
            } else {
                nextValue = null
            }
        }

        onChange(nextValue)
    }

    _isActive(item) {
        const {multi, value, identify} = this.props

        if (multi) {
            const itemId = identify(item)
            return value && value.find((v) => identify(v) == itemId) != null || false
        }
        return item == value
    }

    _enhance(children) {
        return React.Children.map(children, (child) => {
            if (child && child.type && child.type.displayName == 'Button') {
                const {value} = child.props

                return React.cloneElement(child, {
                    active: this._isActive(value),
                    onClick: (e) => this._toggle(e, value)
                })
            }
            if (child && child.props) {
                const {children} = child.props

                return children && React.cloneElement(child, {
                    children: this._enhance(children)
                }) || child
            }
            return child
        })
    }

    render() {
        const {children, multi, value, onChange} = this.props

        return (
            <div>
                {this._enhance(children)}
            </div>
        )
    }
}

export default ButtonToggle


// WEBPACK FOOTER //
// ./lib/core/components/ButtonToggle.js